import React, { useState } from 'react';
import Tesseract from 'tesseract.js';

const ImageTextRecognition = () => {
  const [imageText, setImageText] = useState('');
  const [loading, setLoading] = useState(false);

  const handleFileInputChange = async (event) => {
    const file = event.target.files[0];

    if (file) {
      setLoading(true);

      Tesseract.recognize(
        file,
        'eng', // English language data
        { logger: m => console.log(m) } // Enable logger for debugging
      ).then(({ data: { text } }) => {
        setImageText(text);
        setLoading(false);
      }).catch(error => {
        console.error('Error recognizing text:', error);
        setLoading(false);
      });
    }
  };

  return (
    <div>
      <input type="file" onChange={handleFileInputChange} />
      {loading ? <p>Loading...</p> : null}
      <div>
        <h2>Extracted Text:</h2>
        <p>{imageText}</p>
      </div>
    </div>
  );
};

export default ImageTextRecognition;
